/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patient_list': {
    width: 24,
    height: 24,
    viewBox: '0 -960 960 960',
    data: '<path pid="0" d="M640-400q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35zM400-160v-76q0-21 10-40t28-30q45-27 95.5-40.5T640-360q56 0 106.5 13.5T842-306q18 11 28 30t10 40v76H400zm86-80h308q-35-20-74-30t-80-10q-41 0-80 10t-74 30zm154-240q17 0 28.5-11.5T680-520q0-17-11.5-28.5T640-560q-17 0-28.5 11.5T600-520q0 17 11.5 28.5T640-480zm0-40zm0 280zM120-400v-80h320v80H120zm0-320v-80h480v80H120zm324 160H120v-80h360q-14 17-22.5 37T444-560z"/>'
  }
})
